import {useCurrentState} from "../globalState";
import React from "react";
import AccountSettings from "./AccountSettings";

function UserPage(props) {
    let [user, _] = useCurrentState("user");
    let [title, setTitle] = useCurrentState("title");
    setTitle("User Settings");
    return <React.Fragment>
        {user.email ? <AccountSettings/> : null}
    </React.Fragment>;
}

export default UserPage;